module.exports = __webpack_public_path__ + "img/IdeaBuddyFont.88eec4e7.svg";